import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useApp } from '../contexts/AppContext';

export const AuthHandler = () => {
  const { user, loading, needsOnboarding } = useApp();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!loading) {
      if (user && needsOnboarding && location.pathname !== '/signup') {
        // navigate('/signup');
      } else if (user && !needsOnboarding) {
        const redirectPath = sessionStorage.getItem('redirectPath');
        if (redirectPath) {
          sessionStorage.removeItem('redirectPath');
          navigate(redirectPath);
        } else if (location.pathname === '/signin' || location.pathname === '/signup') {
          navigate('/dashboard');
        }
      }
    }
  }, [user, loading, needsOnboarding, navigate, location.pathname]);

  return null;
};